<template>
  <header class="app-topbar">
    <router-link class="brand d-lg-none" to="/">
      <BrandMark :size="32" />
      <span>SSU Admin</span>
    </router-link>

    <div ref="menuRoot" class="dropdown ms-auto" v-if="loggedIn">
      <button type="button" class="btn btn-link text-decoration-none d-flex align-items-center gap-2 px-1"
        aria-haspopup="true" :aria-expanded="userMenuOpen ? 'true' : 'false'" @click="userMenuOpen = !userMenuOpen">
        <span class="d-none d-lg-inline text-body">{{ name }}</span>
        <span class="avatar-initials avatar-sm">{{ initials }}</span>
      </button>
      <div class="dropdown-menu dropdown-menu-end shadow" :class="{ show: userMenuOpen }" data-bs-popper="static">
        <div class="px-3 py-2">
          <div class="fw-semibold">{{ name }}</div>
          <div class="small text-body-secondary">Version {{ appVersion }}</div>
        </div>
        <div class="dropdown-divider"></div>
        <button class="dropdown-item" type="button" @click="logout">Abmelden</button>
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { useStore } from "vuex";
import BrandMark from "@/components/frame/BrandMark.vue";
import { AuthenticationContext } from "@/auth/msal-context";

defineOptions({ name: "NavbarComponent" });

const store = useStore();
const userMenuOpen = ref(false);
const menuRoot = ref(null);

const appVersion = computed(() => store.getters.appVersion);
const name = computed(() => AuthenticationContext.getActiveAccount()?.name ?? "");
const loggedIn = computed(() => AuthenticationContext.isAuthenticated());
const initials = computed(() =>
  name.value
    .split(" ")
    .filter(Boolean)
    .map((part) => part[0])
    .slice(0, 2)
    .join("")
    .toUpperCase()
);

const closeOnOutsideClick = (event) => {
  if (menuRoot.value && !menuRoot.value.contains(event.target)) {
    userMenuOpen.value = false;
  }
};

const logout = () => {
  userMenuOpen.value = false;
  AuthenticationContext.logout();
};

onMounted(() => document.addEventListener("click", closeOnOutsideClick));
onBeforeUnmount(() => document.removeEventListener("click", closeOnOutsideClick));
</script>
